import { render, staticRenderFns } from "./priceList.vue?vue&type=template&id=347ed0fa&scoped=true&"
import script from "./priceList.vue?vue&type=script&lang=js&"
export * from "./priceList.vue?vue&type=script&lang=js&"
import style0 from "./priceList.vue?vue&type=style&index=0&id=347ed0fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347ed0fa",
  null
  
)

export default component.exports